module.exports = __webpack_public_path__ + "img/screencast.03b37077.svg";